import React from "react"
import styled from "styled-components"
import { StaticImage } from "gatsby-plugin-image"
import Img from "gatsby-image"
import Container from "../../partials/container"
import { color } from "../../../components/colors"
import { FlexBox } from "../../../components/flexbox"
import SectionTitle from "../../atoms/section-title"
import Text from "../../atoms/text"
import Icon from "../../atoms/icon"
import HexesSVG from "../../../images/hexes.inline.svg"
import DotsSVG from "../../../images/dots.inline.svg"
import CrossSVG from "../../../images/cross.inline.svg"
import { typography } from "../../../components/typography"

const HomepageAboutSection = ({ data }) => (
  <About id="zespol">
    {/* <Icon
      icon={<HexesSVG />}
      hidden
      showMD
      height="382px"
      width="268px"
      absolute
      right="0"
      bottom="0"
    /> */}
    <Container>
      <SectionTitle
        title={data.oNasTytul}
        underline
        lineWidth="32px"
        pt="90px"
        mb="24px"
      />
      <Content>
        {data.oNasOsoby.map((content, i) => {
          if (i % 2) {
            return (
              <FlexBox p={"64px 0 0 0"} direction="column" directionMD="row">
                <FlexBox
                  className="image-left"
                  align="center"
                  width="100%"
                  widthMD="49.6%"
                  prMD="30px"
                  prLG="123px"
                  mb="64px"
                  mbMD="0"
                  relative
                  stretch
                >
                  <ImgWrapper>
                    {/* <Img
                      fixed={content.oNasTlo.localFile.childImageSharp.fluid}
                      className="background"
                    />
                    <Img
                      fixed={
                        content.oNasZdjecie.localFile.childImageSharp.fluid
                      }
                      className="person"
                    /> */}
                    <NameBox>
                      <Text
                        text={content.oNasImie}
                        typography={typography.h400}
                      />
                      <Text
                        text={content.oNasZawod}
                        color={color.primary40}
                        typography={typography.bodyM}
                      />
                    </NameBox>
                  </ImgWrapper>
                </FlexBox>
                <FlexBox
                  className="content-right"
                  direction="column"
                  justify="center"
                  align="flex-start"
                  height="100%"
                  width="100%"
                  widthMD="50.4%"
                >
                  <Text text={content.oNasTekst} />
                </FlexBox>
              </FlexBox>
            )
          } else {
            return (
              <FlexBox
                p={i == 0 ? "0" : "64px 0 0 0"}
                direction="column"
                directionMD="row"
              >
                <FlexBox
                  className="content-right"
                  direction="column"
                  justify="center"
                  align="flex-start"
                  height="100%"
                  width="100%"
                  widthMD="50.4%"
                  order="2"
                  orderMD="1"
                >
                  <Text text={content.oNasTekst} />
                </FlexBox>
                <FlexBox
                  className="image-right"
                  align="center"
                  width="100%"
                  widthMD="49.6%"
                  plMD="30px"
                  plLG="123px"
                  relative
                  order="1"
                  orderMD="2"
                  mb="64px"
                  mbMD="0"
                  stretch
                >
                  <ImgWrapper>
                    {/* <Img
                      fixed={content.oNasTlo.localFile.childImageSharp.fluid}
                      className="background"
                    />
                    <Img
                      fixed={
                        content.oNasZdjecie.localFile.childImageSharp.fluid
                      }
                      className="person"
                    /> */}
                    <NameBox>
                      <Text
                        text={content.oNasImie}
                        typography={typography.h400}
                      />
                      <Text
                        text={"Radca Prawny"}
                        color={color.primary40}
                        typography={typography.bodyM}
                      />
                    </NameBox>
                  </ImgWrapper>
                </FlexBox>
              </FlexBox>
            )
          }
        })}
      </Content>
    </Container>
  </About>
)

export default HomepageAboutSection

const About = styled.section`
  width: 100%;
  position: relative;
  padding: 0 0 64px;

  @media (min-width: 769px) {
    padding: 36px 0 140px;
  }
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (min-width: 769px) {
    flex-direction: row;
    flex-wrap: wrap;
  }

  .image-left,
  .image-right {
    max-width: 500px;
    .gatsby-image-wrapper {
      overflow: visible !important;
      //display: none !important;
      /* border-radius: 50%;
      overflow: hidden !important; */

      /* @media (min-width: 769px) {
        display: block !important;
      } */

      picture {
        display: flex;
        justify-content: center;
        align-center: center;
        width: 100%;

        &::before {
          content: "";
          display: block;
          padding-top: 100%;
        }
      }

      img {
        overflow: hidden;
        //object-position: top center !important;
      }

      /* &::before {
        content: "";
        display: block;
        height: 100%;
        width: 100%;
        background-color: ${color.neutral40};
        box-shadow: 0px 10px 20px rgba(90, 116, 203, 0.2);
        border-radius: 4px;
        position: absolute;
        bottom: -10px;
        left: -10px;
        z-index: -1;
      } */
    }
  }

  .person img {
    object-position: center 20% !important;
  }
`

const ImgWrapper = styled.div`
  position: relative;
  width: 100%;

  .background {
    position: absolute !important;
    inset: 0 0 0 0;
    z-index: 0;
  }
`

const NameBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  left: 50%;
  bottom: -45px;
  width: 80%;
  background-color: ${color.white};
  transform: translateX(-50%);
  z-index: 2;
  box-shadow: 0 0 20px 0 rgb(0 0 0 / 10%);
  padding: 15px 0;
`

const Name = styled.div``
const Title = styled.div``
